import { ReactNode } from 'react';
import {
  Box,
  Button,
  ButtonProps,
  FileButton,
  FileButtonProps,
  Text,
} from '@mantine/core';
import { IconFileUpload } from '@tabler/icons-react';
import { UploadedFileData } from 'uploadthing/types';

import { useUploadThing } from '../../../../../../services/upload';

interface FileUploadButtonProps
  extends Omit<FileButtonProps<true>, 'onChange'> {
  utUploadKey:
    | 'technicalPlanTopViewsUploader'
    | 'technicalPlanCoverImagesUploader'
    | 'constructionSiteReportImagesUploader';
  onChange?: (files: UploadedFileData[]) => void;
  leftSection?: React.ReactNode;
  placeholder?: string;
}

export function FileUploadButton({
  utUploadKey,
  onChange,
  leftSection,
  placeholder,
  buttonProps,
  error,
  ...props
}: Omit<FileUploadButtonProps, 'children'> & {
  buttonProps?: ButtonProps;
  error?: ReactNode;
}) {
  const { startUpload, isUploading } = useUploadThing(utUploadKey);

  const handleChange = async (files: File[]) => {
    if (files.length > 0) {
      const uploadResult = await startUpload(files);
      if (uploadResult && onChange) {
        onChange(uploadResult);
      }
    } else if (onChange) {
      onChange([]);
    }
  };

  return (
    <Box>
      <FileButton
        onChange={handleChange}
        multiple={props.multiple}
        accept={props.accept}
      >
        {props => (
          <Button
            loading={isUploading}
            leftSection={leftSection || <IconFileUpload size={14} />}
            {...buttonProps}
            {...props}
          >
            {placeholder || 'Select file'}
          </Button>
        )}
      </FileButton>
      {error && (
        <Text c="red" size="sm">
          {error}
        </Text>
      )}
    </Box>
  );
}
